import Loading from 'components/Loading';
import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';

import CardTimer from '../CardTimer';
import SmallCardCount from './SmallCardCount';

export function SmallCountAndTimer(props: ReturnType<typeof mapStateToProps>) {
  const {
    isFetching,
  } = props;

  if (isFetching) {
    return <Loading spinner small />;
  }
  return (
    <p>
      <SmallCardCount />
      {' '}
      <CardTimer formatter={str => `(${str}.)`} />
    </p>
  );
}

SmallCountAndTimer.displayName = 'SmallCountAndTimer';

const mapStateToProps = ({ cards: { isFetching } }: IAppState) => ({ isFetching });

export default connect(mapStateToProps)(SmallCountAndTimer);